@if (regionService.regions().length) {
    <div class="flex min-h-screen bg-neutral-100">
        @if (authStore.isAuthorized()) {
            <app-nav class="sticky top-0 h-screen w-72 shrink-0 self-start"></app-nav>
        }
        <main class="min-w-0 flex-1 bg-white">
            <router-outlet></router-outlet>
        </main>
    </div>
}
